import { Pipe, PipeTransform } from '@angular/core';
import { Note } from '../shared/models/note/note';

@Pipe({
  name: 'filterNote',
})
export class FilterNotePipe implements PipeTransform {
  transform(items: Note[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter((it) => {
      return it.note?.toLocaleLowerCase().includes(searchText);
    });
  }
}
